import React, { useEffect, useRef, useState } from "react"

import './liveSalesFeed.css'
import { SaleListItem } from "../../state/reducers/machine";
import { useInterval } from "../../utils/customHooks";
import { toAgo } from "../../functions";


export const LiveSalesFeed = ({ sales, displayStores }: { sales: Array<SaleListItem>, displayStores?: Array<string> }) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const eventsRef = useRef<Array<{ message: string, timestamp: number, element: HTMLDivElement }>>([])
    const [displayed, setDisplayed] = useState<Array<SaleListItem>>([])
    const fadeDuration = 1000000; // 100 seconds
    const checkInterval = 10000; // 10 second


    function addEvent(message: string, timestamp: number) {
        if (!containerRef.current)
            return

        if ('Unknown' === message)
            return

        while (eventsRef.current.length > 10) {
            eventsRef.current[eventsRef.current.length]?.element?.remove()
            eventsRef.current.pop();
        }

        if (eventsRef.current.some(item => (item.message === message && item.timestamp === timestamp))) {
            return
        }

        const line = document.createElement('div');
        line.className = 'event-line';
        line.textContent = message;
        line.style.opacity = '1';

        // Prepend to overlay
        containerRef.current.insertBefore(line, containerRef.current.firstChild);

        // Track the event and its DOM element
        eventsRef.current.unshift({ message, timestamp, element: line });

        updateEvents();
    }

    useEffect(() => {
        const newSales: Array<SaleListItem> = []

        sales.forEach(sale => {
            if(displayStores)
                if(!displayStores.some(s => sale.store === s))
                    return;

            if (!displayed.some(d => d.store === sale.store && d.timestamp === sale.timestamp))
                newSales.push(sale)
        })

        newSales.reverse().forEach(sale => {
            addEvent(`${sale.store}`, sale.timestamp)
        })
        setDisplayed(curr => [...newSales, ...curr])

    }, [sales, displayStores])

    function updateEvents() {
        const now = Date.now();


        for (let i = eventsRef.current.length - 1; i >= 0; i--) {
            const event = eventsRef.current[i];
            const age = now - event.timestamp;
            const agoString = toAgo(new Date(event.timestamp), true)
            event.element.innerHTML = `<span class="storeName">${event.message}</span><span class="timeAgo">${agoString}</span>`

            if (age > fadeDuration) {
                event.element?.remove();
                eventsRef.current.splice(i, 1);
            } else {
                const opacity = 1 - age / fadeDuration;
                if (event.element) {
                    if (opacity < 0.3) {

                        event.element?.remove();
                        eventsRef.current.splice(i, 1);

                    }
                    // event.element.style.opacity = opacity + '';

                }
            }
        }
    }


    useInterval(() => {
        updateEvents()
    }, checkInterval)

    return (
        <div id="live-sales-feed-container" ref={containerRef}></div>
    )
}